import {
  Modal,
  ModalContent,
  ModalOverlay,
  ModalProps,
} from "@chakra-ui/react";

export const OptionalModal = ({
  children,
  hasModal,
  ...props
}: ModalProps & {
  hasModal: boolean;
}) => {
  if (!hasModal) return <> {children}</>;
  return (
    <Modal {...props}>
      <ModalOverlay />
      <ModalContent>{children}</ModalContent>
    </Modal>
  );
};
